import React,{useState, useEffect} from "react";
import classes from './Header.module.scss'
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ModalSetLanguage from "../ModalSetLanguage/ModalSetLanguage";
import { useTranslation } from "react-i18next";
import { setLanguageWebsite } from "../../bll/AuthReducer";

const Header = (props:any) => {

    const[isToken, setToken] = useState(Boolean)
    const {t} = useTranslation()
    const [modalActive, setModalActive] = useState(false)
    const [currentLanguage, setCurrentLanguage] = useState('EN') 

    useEffect(() => {
        if(localStorage.getItem('token')){
            setToken(true)
        }
        else{
            setToken(false)
        }
    }, [])

    const hideModal = () => {
        setModalActive(false)
    }

    const openModalSwitchLanguages = () => {
        setModalActive(true)
    }

    return(
        <div className={classes.header}>
            <Link to="/">
                <img className={classes.header_logo} src={require('../../img/logoHeader.png')} alt = 'logo'/>
            </Link>
            <div className={classes.header__right}>
                <Link to="/cpayToken" className={classes.header__right__button}>
                    <img className={classes.header__right__button_img} src={require('../../img/walletHeader.png')} alt = 'wallet'/>
                    <p className={classes.header__right__button_text}>{t('header.buy')}</p>
                </Link>
                <div className={classes.header__right__language}>
                    <img className={classes.header__right__language_img} src={require('../../img/languageHeader.png')} alt = 'language' onClick={openModalSwitchLanguages}/>
                    <p className={classes.header__right__language_text} onClick={openModalSwitchLanguages}>{props.data.appLanguage}</p>
                    <ModalSetLanguage 
                                modalActive={modalActive} 
                                setModalActive={setModalActive} 
                                hideModal={hideModal}
                                currentLanguage={props.data.appLanguage}
                                setCurrentLanguage={(lng:any) => props.setLanguageWebsite(lng)}/> 
                </div>
                {/* <p className={classes.header__right_auth}>Authorization</p> */}
                {isToken ?
                    <Link to="/personalAccount" className={classes.header__right_auth}>{t('header.user')}</Link> 
                :
                    <Link to="/signUp" className={classes.header__right_auth}>{t('header.autorisation')}</Link>
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    data: state.AuthReducer,
})
  
export default connect(mapStateToProps, {setLanguageWebsite})(Header)